import { mediaUrl } from '../lib/api';

// =========== AVATARY ===========
// Obrázky leží jako hotové SVG v public/assets/avatars/ a generuje je
// scripts/generate-avatars.mjs (spouští se přes `npm run avatars`).
// Postavičky kreslí styl Lorelei od Lisy Wischofsky, licence CC0.
//
// Hodnoty ve `value` se nesmí měnit – jsou uložené u uživatelů v databázi.
// Přidávat nové se ale může kdykoliv.

const src = (value) => `/assets/avatars/${value}.svg`;

// Popisky jsou ve slovníku pod `avatar.*` – překládají se až při vykreslení.
export const avatarOptions = [
  // ── Femininní ──
  { value: 'fem-pink', klic: 'avatar.fem-pink', gender: 'feminine', image: src('fem-pink') },
  { value: 'fem-lavender', klic: 'avatar.fem-lavender', gender: 'feminine', image: src('fem-lavender') },
  { value: 'fem-peach', klic: 'avatar.fem-peach', gender: 'feminine', image: src('fem-peach') },
  { value: 'fem-dark', klic: 'avatar.fem-dark', gender: 'feminine', image: src('fem-dark') },
  { value: 'fem-straight', klic: 'avatar.fem-straight', gender: 'feminine', image: src('fem-straight') },
  { value: 'fem-ponytail', klic: 'avatar.fem-ponytail', gender: 'feminine', image: src('fem-ponytail') },
  { value: 'fem-bun', klic: 'avatar.fem-bun', gender: 'feminine', image: src('fem-bun') },

  // ── Maskulinní ──
  { value: 'masc-blue', klic: 'avatar.masc-blue', gender: 'masculine', image: src('masc-blue') },
  { value: 'masc-teal', klic: 'avatar.masc-teal', gender: 'masculine', image: src('masc-teal') },
  { value: 'masc-navy', klic: 'avatar.masc-navy', gender: 'masculine', image: src('masc-navy') },
  { value: 'masc-brown', klic: 'avatar.masc-brown', gender: 'masculine', image: src('masc-brown') },
  { value: 'masc-goatee', klic: 'avatar.masc-goatee', gender: 'masculine', image: src('masc-goatee') },
  { value: 'masc-gray', klic: 'avatar.masc-gray', gender: 'masculine', image: src('masc-gray') },
  { value: 'masc-short', klic: 'avatar.masc-short', gender: 'masculine', image: src('masc-short') },

  // ── Neutrální ──
  { value: 'nb-mint', klic: 'avatar.nb-mint', gender: 'neutral', image: src('nb-mint') },
  { value: 'nb-lilac', klic: 'avatar.nb-lilac', gender: 'neutral', image: src('nb-lilac') },
  { value: 'nb-curly', klic: 'avatar.nb-curly', gender: 'neutral', image: src('nb-curly') },
  { value: 'nb-sage', klic: 'avatar.nb-sage', gender: 'neutral', image: src('nb-sage') },
  { value: 'nb-mohawk', klic: 'avatar.nb-mohawk', gender: 'neutral', image: src('nb-mohawk') },
  { value: 'nb-undercut', klic: 'avatar.nb-undercut', gender: 'neutral', image: src('nb-undercut') },
  { value: 'nb-shaved', klic: 'avatar.nb-shaved', gender: 'neutral', image: src('nb-shaved') },
  { value: 'nb-glasses', klic: 'avatar.nb-glasses', gender: 'neutral', image: src('nb-glasses') },
  { value: 'nb-freckles', klic: 'avatar.nb-freckles', gender: 'neutral', image: src('nb-freckles') },

  // ── Zvířata ──
  { value: 'animal-cat', klic: 'avatar.animal-cat', gender: 'animal', image: src('animal-cat') },
  { value: 'animal-fox', klic: 'avatar.animal-fox', gender: 'animal', image: src('animal-fox') },
  { value: 'animal-rabbit', klic: 'avatar.animal-rabbit', gender: 'animal', image: src('animal-rabbit') },
  { value: 'animal-panda', klic: 'avatar.animal-panda', gender: 'animal', image: src('animal-panda') },
  { value: 'animal-owl', klic: 'avatar.animal-owl', gender: 'animal', image: src('animal-owl') },

  // ── Symboly ──
  { value: 'sym-flower', klic: 'avatar.sym-flower', gender: 'symbol', image: src('sym-flower') },
  { value: 'sym-butterfly', klic: 'avatar.sym-butterfly', gender: 'symbol', image: src('sym-butterfly') },
  { value: 'sym-rainbow', klic: 'avatar.sym-rainbow', gender: 'symbol', image: src('sym-rainbow') },
  { value: 'sym-star', klic: 'avatar.sym-star', gender: 'symbol', image: src('sym-star') },
  { value: 'sym-heart', klic: 'avatar.sym-heart', gender: 'symbol', image: src('sym-heart') },
  { value: 'sym-lotus', klic: 'avatar.sym-lotus', gender: 'symbol', image: src('sym-lotus') },

  // ── Vlastní fotka ──
  { value: 'custom', klic: 'avatar.custom', gender: 'custom', image: null },
];

// Náhrada, když uživatel ještě avatar nemá – kolečko s prvním písmenem přezdívky
const initialsAvatar = (name, bg = '#8A7CFF') => {
  const initials = (name || '?').charAt(0).toUpperCase();
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="50" fill="${bg}"/><text x="50" y="56" text-anchor="middle" dominant-baseline="middle" font-size="38" font-family="DM Sans,sans-serif" font-weight="600" fill="white">${initials}</text></svg>`;
  return `data:image/svg+xml,${encodeURIComponent(svg)}`;
};

export const getAvatarImage = (avatarValue, customImage = null) => {
  // Vlastní nahraný avatar je soubor na serveru a vyžaduje přihlášení –
  // proto k adrese připojíme token. Kreslené avatary jsou součástí aplikace.
  if (avatarValue === 'custom' && customImage) return mediaUrl(customImage);
  const found = avatarOptions.find(a => a.value === avatarValue);
  if (found?.image) return found.image;
  return avatarOptions[0].image;
};

export const getAvatarFallback = (username) => initialsAvatar(username);
